import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=350a42b8&scoped=true&"
import script from "./Browser.vue?vue&type=script&lang=js&"
export * from "./Browser.vue?vue&type=script&lang=js&"
import style0 from "./Browser.vue?vue&type=style&index=0&id=350a42b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a42b8",
  null
  
)

export default component.exports